import Swiper from 'swiper/dist/js/swiper';
import {
   isTouchMode,
   slugify
} from './utils'

const NAME = 'gsx$name'
const TAG = 'gsx$tag'
const ICON_CLASS = 'gsx$iconclass'



class SwiperNavbar {
   constructor(selector, options) {
      if (!document.querySelector(selector)) return false

      this.selector = selector
      this.activeIndex = 0
      this.defaults = {
         activeIndex: 0,
         swiperNavSelector: '.swiper-container',
         activeItemClass: 'active'
      }
      this.options = Object.assign(this.defaults, options)


      this.init();
   }

   init() {
      this.containerEl = document.querySelector(this.selector)
      const handleOnInit = () => {
         if (typeof this.options.onInit === "function") {
            this.options.onInit(this)
         }
      }

      if (this.options.sheetURL) {
         this.renderFromSpreadSheet(() => {
            this.initTabsNav()
            handleOnInit()
         })

      } else {
         if ( this.options.jsonScriptId ) {
            const jsonScriptElem = document.getElementById(this.options.jsonScriptId) ;
            if ( jsonScriptElem ) {
               const dataScript = JSON.parse( jsonScriptElem.innerHTML);
               this.renderFromJsonScript(dataScript);
               this.initTabsNav()
               handleOnInit()
               // this.options.onLoadData(dataScript.entry)
            }         
         }      
      }
   }

   renderFromSpreadSheet(callback) {
      if (typeof $ !== "undefined") {
         let _self = this

         $.getJSON(_self.options.sheetURL)
            .done((res, textStatus) => {
               if (textStatus === "success" && res.feed) {               
                  this.swiperHTML = `
                     <div class="swiper-container navbar-slider__nav">
                        <div class="swiper-wrapper navbar-slider__wrapper">`

                  this.swiperHTML += res.feed.entry.map((data, index) => {
                     return `<a href="#section-${slugify(data[NAME].$t)}" data-tag="${data[TAG].$t}" title="${data[NAME].$t}" class="swiper-slide navbar-slider__item text-center ${index === 0 ? this.options.activeItemClass : ''}">
                                 <div class="navbar-slider__item__inner">
                                    <span class="c-icon-cat ${data[ICON_CLASS].$t}"></span>
                                    <span class="navbar-slider__item__label">${data[NAME].$t}</span>
                                 </div>
                            </a>`
                  }).join('')
                  this.swiperHTML += '</div></div>'
                  this.containerEl && (this.containerEl.innerHTML = this.swiperHTML)
                  if (typeof this.options.onLoadData === "function") {
                     this.options.onLoadData(res.feed.entry)
                  }
                  callback && callback()
               }
            })
      }
   }

   renderFromJsonScript(dataJson) {
      this.swiperHTML = `
      <div class="swiper-container navbar-slider__nav">
         <div class="swiper-wrapper navbar-slider__wrapper">`

      this.swiperHTML += dataJson.entry.map((data, index) => {

         return `<a href="#section-${slugify(data[NAME].$t)}" data-tag="${data[TAG].$t}" title="${data[NAME].$t}" class="swiper-slide navbar-slider__item text-center ${index === 0 ? this.options.activeItemClass : ''}">
                        <div class="navbar-slider__item__inner" >
                           <span class="c-icon-cat ${data[ICON_CLASS].$t}"></span>
                           <span class="navbar-slider__item__label">${data[NAME].$t}</span>
                        </div>
                   </a>`
      }).join('')

      this.swiperHTML += '</div></div>'
      this.containerEl && (this.containerEl.innerHTML = this.swiperHTML)
   }

   initTabsNav() {
      this.swiper = new Swiper(`${this.selector} ${this.options.swiperNavSelector}`, {
         slidesPerView: 'auto',
         //freeMode: true,
         //freeModeMomentumRatio: .3,
         init: false,
      })

      this.swiper.on('init', () => {

         this.swiperNavActive = this.swiper.slides[this.options.activeIndex]

         this.setNavActive(this.swiperNavActive)

         this.swiperNavItems = this.swiper.slides

         for (let i = 0; i <= this.swiperNavItems.length; i++) {
            if (this.swiperNavItems[i]) {
               this.swiperNavItems[i].setAttribute('data-index', i)
               this.swiperNavItems[i].addEventListener('click', e => {
                  this.handleNavItemClick(e, this.swiperNavItems[i])
                  e.stopPropagation();
               })
            }
         }
      })

      this.swiper.init()
   }

   keepItemInView() {
      this.swiper.slideTo(this.isSlidingForward && this.activeIndex > 0 ? this.activeIndex : this.activeIndex - 1)
   }

   handleNavItemClick(e, navEl) {
      e && e.preventDefault()
      this.setNavActive(navEl)
      this.navigatingByClick = true
      const curActiveIndex = this.activeIndex
      this.activeIndex = navEl.dataset.index
      this.isSlidingForward = curActiveIndex < this.activeIndex
      if (isTouchMode()) {
         this.keepItemInView()
      }
   }

   setNavActive(newNavEl) {
      if (typeof newNavEl !== "undefined") {
         this.swiperNavActive.classList.remove(this.options.activeItemClass)
         newNavEl.classList.add(this.options.activeItemClass)
         this.swiperNavActive = newNavEl
      }
   }
}

export default SwiperNavbar